module.exports = __webpack_public_path__ + "static/img/logo_text.f4d5762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_text.png
// module id = 1147
// module chunks = 1